import React, { useEffect, useState } from "react";
import classes from "./CategoryContentPage.module.css";
import { useNavigate, useParams } from "react-router-dom";
import { useSearchParams } from "react-router-dom";
import CategoryCards from "../components/CategoryCards";
import DragCards from "../components/DragCards";
import SkeletonCardsLoading from "../components/SkeletonCardsLoading";
import CategoryCardBanner from "../components/CategoryCardBanner";
import { getContentApi } from "../http/http";
import TitleLoading from "../components/TitleLoading";
import TitleHeader from "../components/TitleHeader";

const CategoryContentPage = () => {
    const navigate = useNavigate();
    const [open, setOpen] = useState(false);
    const [data, setData] = useState([]);
    const [categoryData, setCategoryData] = useState([]);
    const [loading, setLoading] = useState(true);
    const params = useParams();
    const [category, setCategory] = useState(null);

    const [searchParams, setSearchParams] = useSearchParams();

    const [dataLoading, setDataLoading] = useState(false);

    const [active, setActive] = useState(null);

    const fetchData = async (cid) => {
        try {
            console.log(cid, 'cid---');
            setLoading(true);
            const response = await getContentApi();
            console.log(response?.data, 'response---');
            setData(response?.data);
            console.log(response?.data?.filter((item) => item?.main_category_id == cid), 'filteredData---');
            setCategoryData(response?.data?.filter((item) => item?.main_category_id == cid));
            setLoading(false);
        } catch (error) {
            setLoading(false);
            console.log(error, "error");
        }
    };

    useEffect(() => {
        if (searchParams.get("main_category_id")) {
            console.log(searchParams.get("main_category_id"), 'searchParams---');
            console.log(searchParams.get("sub_category_id"), 'sub_category_id---');
            fetchData(searchParams.get("main_category_id"));
            setActive(searchParams.get("sub_category_id"));
            setCategory(searchParams.get("main_category_id"));
        }
        else {
            navigate("/home");
        }
    }, [searchParams, params]);



    console.log(categoryData, 'categoryData---');

    return (
        <main className={classes.main}>
            <header className={classes.header}>
                <nav className={classes.nav}>
                    <div className={classes.logo_container}
                        onClick={() => {
                            navigate("/");
                        }}
                    >
                        <img src="/assets/images/logo.png" alt="logo" className={classes.logo} />
                    </div>

                </nav>

            </header>

            <section className={classes.main}>
                {loading ? (
                    <>
                        <TitleLoading />
                        <SkeletonCardsLoading />
                        <TitleLoading />
                        <SkeletonCardsLoading />
                    </>
                ) : (
                    <>
                        <CategoryCards data={categoryData?.[0]?.sub_category} active={active} categoryChangeHandler={(value) => {
                            setDataLoading(true);
                            setActive(value);
                            setCategory(value);
                            if (value) {
                                setSearchParams({ main_category_id: searchParams.get("main_category_id"), sub_category_id: value })
                            }
                            else {
                                setSearchParams({ main_category_id: searchParams.get("main_category_id") })
                            }
                            setTimeout(() => {
                                setDataLoading(false);
                            }, 500);
                        }} />
                        {active == null ? (
                            <>
                                {categoryData?.map((categoryItem, index) => {
                                    console.log(categoryItem, 'categoryItem---');
                                    return categoryItem?.sub_category?.map((dataItem, idx) => (<><TitleHeader
                                        title={dataItem?.sub_category_name}
                                        hideFilter={true}
                                        key={idx}
                                    />
                                        <DragCards
                                            data={dataItem?.sub_category_videos_list}

                                            main_category_id={categoryItem?.main_category_id}
                                            sub_category_id={dataItem?.sub_category_id}

                                        // category={data?.[1]}
                                        />
                                    </>))
                                })}
                            </>
                        )
                            : (
                                <>
                                    {/* <TitleHeader title={`Explore ${categoryData?.[0].main_category_name}`} data={categoryData?.[0]?.sub_category}
                    hideFilter={true}
                  /> */}
                                    {dataLoading ? <SkeletonCardsLoading /> :
                                        // <DragCards
                                        //   data={categoryData?.[0]?.sub_category?.filter((item) => item?.sub_category_id === active)?.[0].sub_category_videos_list}
                                        //   category={categoryData?.[0]}
                                        // />
                                        <div className={classes.cards_container}>
                                            {categoryData?.[0]?.sub_category?.filter((item) => item?.sub_category_id == active)?.[0].sub_category_videos_list?.map((dataItem, idx) => {
                                                return (
                                                    <React.Fragment key={idx}>
                                                        <CategoryCardBanner dataItem={dataItem} episode={idx}
                                                            main_category_id={searchParams.get("main_category_id")}
                                                            sub_category_id={active}
                                                        />
                                                    </React.Fragment>
                                                );
                                            })}
                                        </div>
                                    }
                                </>
                            )}

                    </>
                )}
            </section>
        </main>
    );
};

export default CategoryContentPage;
